import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=b5cf5466&scoped=true"
import script from "./NotificationPopup.vue?vue&type=script&lang=ts"
export * from "./NotificationPopup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPopup.vue?vue&type=style&index=0&id=b5cf5466&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cf5466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5cf5466')) {
      api.createRecord('b5cf5466', component.options)
    } else {
      api.reload('b5cf5466', component.options)
    }
    module.hot.accept("./NotificationPopup.vue?vue&type=template&id=b5cf5466&scoped=true", function () {
      api.rerender('b5cf5466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/NotificationPopup.vue"
export default component.exports